import "@hotwired/turbo-rails";
import "./controllers";
import Tagify from "../assets/javascripts/tagify.min.js";

window.Tagify = Tagify;
